import gql from 'graphql-tag'

export const MOVER_ITEM = gql`
  mutation MoverItemMutation($idItemBiblioteca: ID!, $novaLocalizacao: ID!) {
    moverItemBiblioteca(
      idItemBiblioteca: $idItemBiblioteca
      idNovaLocalizacao: $novaLocalizacao
    ) {
      id
      nome
      pastaPai {
        id
      }
    }
  }
`
